import { render, staticRenderFns } from "./MdtInfo.vue?vue&type=template&id=a9d6d354&scoped=true"
import script from "./MdtInfo.vue?vue&type=script&lang=js"
export * from "./MdtInfo.vue?vue&type=script&lang=js"
import style0 from "./MdtInfo.vue?vue&type=style&index=0&id=a9d6d354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d6d354",
  null
  
)

export default component.exports